module.exports = __webpack_public_path__ + "img/Become-A-Trainer.d5e6dded.png";